import { useMeFavouritePartner } from '@capsicum/common';
import { useFollowedTeamsQuery } from '@capsicum/socios-core';

export const useGettingStarted = () => {
	const { data: followedTeams, isLoading: isFollowedTeamsLoading } = useFollowedTeamsQuery();
	const { favoritePartner, isFavouritePartnerLoading, isFavouritePartnerSsu } = useMeFavouritePartner();
	const hasFavouriteTeam = favoritePartner?.id && !isFavouritePartnerSsu;

	return {
		hasFavouriteTeam,
		isBubblesVisible: hasFavouriteTeam,
		isCarouselVisible: !hasFavouriteTeam || (followedTeams && followedTeams.length <= 3),
		isFavouritePartnerLoading,
		isFollowedTeamsLoading
	};
};
